export enum ExpedienteState {
    EXECUCION = 'A',
    DESERTO = 'D',
    PECHADO = 'P'
}
